module.exports = __webpack_public_path__ + "img/map.cf6b4224.svg";